import React from 'react'
import { Icon } from 'semantic-ui-react'

import { Mode } from '../../redux/types/ui'
import { toast } from 'react-toastify'
import { navigateToProductCreate } from '../../utils/navigate'

interface Props {
  gettingProductId: number | undefined
  lastAction: Mode
  dispatch: any
  row: any
  alias: string
  isBatchLookup: boolean
}

export const TableCellCreate = (props: Props) => {
  const { gettingProductId, lastAction, row, alias, isBatchLookup } = props

  return (
    <Icon
      link
      disabled={gettingProductId != null}
      loading={lastAction === 'create' && gettingProductId === row.values.id}
      name={
        lastAction === 'create' && gettingProductId === row.values.id ? 'spinner' : 'share square'
      }
      color="grey"
      onClick={() => {
        if (isBatchLookup && !alias) {
          toast('An alias is required', {
            containerId: 'error',
          })
          return
        }
        navigateToProductCreate({
          productId: row.values.id,
          search: alias ? `?alias=${encodeURIComponent(alias)}` : undefined,
        })
      }}
    />
  )
}
